import { Link } from "@inertiajs/react";
import styled from "styled-components";

import { useLandingLanguage } from "../../contexts/landing-language";
import { insightPath } from "./paths";
import { formatDate } from "./format";

const Card = styled(Link)`
  display: flex;
  flex-direction: column;
  background: #fff;
  border: 1px solid #ececec;
  border-radius: 14px;
  overflow: hidden;
  text-decoration: none;
  color: inherit;
  transition:
    transform 0.35s cubic-bezier(0.4, 0, 0.2, 1),
    box-shadow 0.35s ease,
    border-color 0.35s ease;

  &:hover {
    transform: translateY(-4px);
    border-color: rgba(201, 169, 97, 0.5);
    box-shadow: 0 18px 40px rgba(0, 0, 0, 0.1);
  }
`;

const Cover = styled.div`
  position: relative;
  aspect-ratio: 16 / 10;
  background-image: url(${(props) => props.$src});
  background-size: cover;
  background-position: center;
  background-color: #f0ede8;
`;

const Chip = styled.span`
  position: absolute;
  top: 14px;
  left: 14px;
  background: rgba(26, 26, 26, 0.82);
  color: #fff;
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 1px;
  text-transform: uppercase;
  padding: 6px 12px;
  border-radius: 999px;
  backdrop-filter: blur(4px);
`;

const Body = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 22px 22px 24px;
  flex: 1;
`;

const Title = styled.h3`
  font-size: 18px;
  line-height: 1.35;
  font-weight: 700;
  color: #1a1a1a;
  margin: 0;
`;

const Excerpt = styled.p`
  font-size: 14px;
  line-height: 1.6;
  color: #5e6278;
  margin: 0;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
`;

const Meta = styled.div`
  margin-top: auto;
  padding-top: 12px;
  font-size: 12.5px;
  color: #8a8f9c;
  display: flex;
  gap: 8px;
  align-items: center;
  flex-wrap: wrap;
`;

const Dot = styled.span`
  width: 3px;
  height: 3px;
  border-radius: 50%;
  background: currentColor;
`;

const ArticleCard = ({ article, showCategory = true }) => {
  const { t, language } = useLandingLanguage();
  if (!article) return null;

  return (
    <Card href={insightPath(language, article.slug)}>
      <Cover $src={article.cover_url}>
        {showCategory && article.category ? (
          <Chip>{article.category.name}</Chip>
        ) : null}
      </Cover>
      <Body>
        <Title>{article.title}</Title>
        <Excerpt>{article.excerpt}</Excerpt>
        <Meta>
          {article.published_date ? (
            <span>{formatDate(article.published_date, language)}</span>
          ) : null}
          {article.reading_minutes ? (
            <>
              <Dot />
              <span>
                {article.reading_minutes} {t.insights.card.minRead}
              </span>
            </>
          ) : null}
        </Meta>
      </Body>
    </Card>
  );
};

export default ArticleCard;
